// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__2XwiO","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__2_Rw5"};